import React from 'react'

import classNames from 'classnames/bind'

import classes from './VerticalCarousel.module.scss'

type Props = {
  pos: number
  idx: number
  length: number
  onClick: (idx: number) => void
  isFull?: boolean
}

type ItemProps = {
  styles: React.CSSProperties
  isActive: boolean
  isHidden?: boolean
  isPrev?: boolean
}

const cx = classNames.bind(classes)

const createItem = (
  position: number,
  idx: number,
  length: number,
  isFull: boolean
) => {
  const getPosition = () => {
    switch (position) {
      case length - 1:
        return { isPrev: true }
      case length + 1:
        break
      case length:
        return { isActive: true }
      default:
        return { isHidden: true }
    }
  }

  /*TODO: Сейчас на макетах нашла только два варианта использования слайдера.
  Поэтому не стала высоту выносить в пропсы. */

  const slideHeight = isFull ? 108 : 42

  const item: ItemProps = {
    styles: {
      transform: `translateY(${position * slideHeight}px)`,
    },
    isActive: false,
    ...getPosition(),
  }

  return item
}

export const SlideItem = ({
  pos,
  idx,
  length,
  isFull = false,
  onClick,
}: Props): JSX.Element => {
  const item = createItem(pos, idx, length, isFull)
  const text = idx + 1 - length > 0 ? idx + 1 - length : idx + 1
  const _classes = cx([
    'carousel__slide-item',
    'button_reset',
    {
      full: isFull,
      active: item.isActive,
      hidden: item.isHidden,
      prev: item.isPrev,
    },
  ])

  return (
    <button
      className={_classes}
      key={`slider_${idx}`}
      style={item.styles}
      onClick={() => onClick(text - 1)}
    >
      <span className={classes.text}>{text > 9 ? text : `0${text}`}</span>
      <div className={classes.line}></div>
    </button>
  )
}
